import { jsx } from "react/jsx-runtime";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { validateTidalLicense } from "../../base/index.js";
function PersonOutlined(props) {
  return /* @__PURE__ */ jsx(
    PersonOutlinedIcon,
    {
      "data-testid": "PersonOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PersonOutlined",
      "data-tidal-icon-meta": "people,persona"
    }
  );
}
PersonOutlined.tidalIconMeta = {
  categories: "people,persona",
  name: "PersonOutlined"
};
validateTidalLicense();
export {
  PersonOutlined
};
//# sourceMappingURL=PersonOutlined.js.map
